import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@ExcelFilterRules/App'

export let startAddInFilterRules = props => {
  const root = createRoot(document.getElementById('app'))
  root.render(<App excel_rules_data={props} />)
}
